
<diV id="eng_dynamicHeight" appSpin [spinnerConfig]='spinnerConfig()'
[ngClass]="{'workbook-preview right-prev-outer': placeOfPreview === 'Workbook', 'eng-preview page A4 overflow-hidden' : placeOfPreview !== 'Workbook' }">

</diV>
